import { Provider } from "react-redux";
import { store } from "./store";
import { ReactNode } from "react";

export default function ReduxProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  return <Provider store={store}>{children}</Provider>;
}
